<ng-template #carConfigModal let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title" translate>vehicles.imports.importFromVehicle</h4>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form #carConfigForm="ngForm" class="row align-items-start justify-content-end p-2"
      (ngSubmit)="searchVehicles(carConfigForm.value)">
      <div class="row align-items-start">
        <ng-container *ngFor="let field of carConfigFields">
          <ng-container>
            <div class="form-group col-4">
              <label translate>{{ field.label }}</label>

              <div *ngIf="field.type === 'selectWithSearch' && field.name === 'make'" style="position: relative;">
                <app-select-with-search [options]="field.options" (selectionChange)="onMakeChange($event)"
                  [defaultSelect]="selectedMake" [disabled]="isRegex"></app-select-with-search>
                  <div *ngIf="field.error" class="error-msg" translate>{{ field.error }}</div>
              </div>

              <div *ngIf="field.type === 'selectWithSearch' && field.name === 'model'" style="position: relative;">
                <app-select-with-search [options]="field.options"
                  (selectionChange)="onModelChange($event)"></app-select-with-search>
                  <div *ngIf="field.error" class="error-msg" translate>{{ field.error }}</div>
              </div>

              <div *ngIf="field.type === 'select'">
                <select class="form-control" [(ngModel)]="carConfigData[field.name]" [name]="field.name"
                  [required]="true">
                  <option value="" disabled selected translate>{{ field.placeholder }}</option>
                  <option value="" translate>global.none</option>
                  <option *ngFor="let option of field.options" [value]="option.value" translate>{{ option.label }}</option>
                </select>
                <div *ngIf="field.error" class="error-msg" translate>{{ field.error }}</div>
              </div>

              <div *ngIf="field.type === 'text' && field.name !== 'vin'">
                <input type="text" class="form-control" [name]="field.name"
                  [placeholder]="field.placeholder | translate" [(ngModel)]="carConfigData[field.name]"
                  [required]="true" />
                <div *ngIf="field.error" class="error-msg" translate>{{ field.error }}</div>
              </div>

              <div *ngIf="field.type === 'text' && field.name === 'vin' && isRegex">
                <input type="text" class="form-control" [name]="field.name"
                  [placeholder]="field.placeholder | translate" [(ngModel)]="vehicle.vehicleInfo.vin" disabled
                  [required]="true" />
              </div>

              <div *ngIf="field.type === 'text' && field.name === 'vin' && !isRegex">
                <input type="text" class="form-control" [name]="field.name"
                  [placeholder]="field.placeholder | translate" [(ngModel)]="carConfigData[field.name]"
                  [required]="true" />
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>
      <button type="submit" class="btn btn-search" translate> <span class="search-icon"><i
            class="fa fa-search" style="font-size: '1rem'; line-height: '0'; height: auto;"></i></span> <span translate>user.search</span></button>
    </form>
    <div *ngIf="isLoading">
      <div *appSpinner="isLoading; message: 'Please wait...'"></div>
    </div>

    <div class="row mt-4" *ngIf="carConfigVehicles && carConfigVehicles.results.length > 0">
      <div class="col-3 mb-2" *ngFor="let vehicle of carConfigVehicles.results" (click)="selectVehicle(vehicle)">
        <div class="vehicle-card" [ngClass]="{ 'selected-vehicle': vehicle.id === selectedVehicleId }">
          <div class="vehicle-image">
            <img *ngIf="vehicle.images && vehicle.images.length > 0" [src]="vehicle.images[0].path" alt="Vehicle Image"
              class="vehicle-img img-fluid" />
          </div>
          <div class="vehicle-details p-2">
            <h5>{{ vehicle.vehicleMake.name }} {{ vehicle.vehicleModel.name }} ({{ vehicle.modelYear }})</h5>
            <p>{{ vehicle.vin}}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="vehicles-cards-empty" *ngIf="carConfigVehicles && !carConfigVehicles.results.length" translate>vehicles.noVehicle</div>
    <ngb-pagination [collectionSize]="carConfigVehicles?.count" [(pageSize)]="carConfigLimit" [(page)]="carConfigPage"
      [maxSize]="5" [rotate]="true" (pageChange)="changeCarConfigPerPage($event)"></ngb-pagination>
    <div *ngIf="!isLoading" style="background: var(--clr-primary-light); padding: 20px;">
      <p translate>vehicles.imports.sendRequestText</p>
      <button class="custom-button btn-red mt-3" style="font-size: 1.2rem;" (click)="requestImages()"
        translate>vehicles.imports.sendRequest</button>
      <p *ngIf="errorMessage" style="color: red; margin-top: 10px;" translate>{{ errorMessage }}</p>
    </div>
  </div>

  <div class="modal-footer">
    <button [disabled]="!selectedVehicleId" class="custom-button btn-red mt-3" style="font-size: 1.2rem;"
      (click)="importImages()" translate>vehicles.importImages</button>
  </div>
</ng-template>